export const getIconWithTitle = (contentList, contentType: string) => {
  const filteredData = contentList.find(
    (content) =>
      content?.isGallery && content?.id?.toLocaleLowerCase() === contentType?.toLocaleLowerCase(),
  );
  return {
    title: filteredData?.title || "",
    icon: filteredData?.icon || "",
    id: filteredData?.id || "",
    fallbackIcon: filteredData?.fallbackIcon || "",
    menuIcon: filteredData?.menuIcon || "",
  };
};
